/* eslint-disable no-useless-escape */
const ChangeEvents = {
	/* Handle Text Input State Change */
	handleInputChange: (event, update, type, validation, maxLength = 25, fieldValidationString) => {
		const dataConfig = event.target.dataset.config;
		let { value, name, id } = event.target;

		if (type === "text") {
			if (name === "MasterCampaignName") {
				value = value.replace(/[^a-zA-Z0-9._ \-]/g, "");
			} else value = value.replace(/[^a-zA-Z0-9 \-]/g, "");
			if (value.length > maxLength) {
				value = value.substring(0, maxLength);
			}
			update(dataConfig, name, value, id, "String");
		} else if (type === "number") {
			value = value.replace(/[^0-9]/g, "");
			if (value.length > maxLength) {
				value = value.substring(0, maxLength);
			}
			if (!isNaN(value)) {
				update(dataConfig, name, value, id, "String");
			}
		} else if (type === "TaxOrMeta") {
			if (!fieldValidationString) {
				if (validation !== null && validation.length !== 0) {
					let formattedValidation = validation[0].substring(validation[0].indexOf("["), validation[0].lastIndexOf("]") + 1);
					formattedValidation = formattedValidation.substring(0, 1) + "^" + formattedValidation.substring(1, formattedValidation.length);
					if (formattedValidation.indexOf("\\\\\\") !== -1) {
						formattedValidation =
							formattedValidation.substring(0, formattedValidation.indexOf("\\\\\\")) +
							"\\\\\\" +
							formattedValidation.substring(formattedValidation.indexOf("\\\\\\") + 1, formattedValidation.length);
					}
					value = value.replace(new RegExp(formattedValidation, "g"), "");
				} else if (validation === null || validation.length === 0) {
					value = value.replace(/[^a-zA-Z0-9-\\/| +]/g, "");
				}
			}
			if (validation !== null && validation.length !== 0 && validation[1] !== undefined) {
				if (value.length > parseInt(validation[1])) {
					value = value.substring(0, parseInt(validation[1]));
				}
			} else if (validation === null || validation.length === 0 || validation[1] === undefined) {
				if (value.length > 30) {
					value = value.substring(0, 30);
				}
			}
			update(dataConfig, name, value, id, "String");
		} else {
			update(dataConfig, name, value, id, "String");
		}
	},

	handleRateChange: (event, update, state) => {
		const dataConfig = event.target.dataset.config;
		let { value, name, id } = event.target;
		value = value.replace(/[^0-9.]/g, "");
		const decimalCount = (value.match(/[.]/g) || []).length;
		if (value === "") {
			value = 0;
		} else if (!value.includes(".")) {
			value = parseInt(value);
		} else if (decimalCount > 1) {
			if (state.formData.Rate) {
				if (decimalCount === 2) {
					if (typeof state.formData.Rate.value === "number" || state.formData.Rate.value.indexOf(".") === -1) {
						value = value.slice(0, value.indexOf(".")) + value.slice(value.indexOf(".") + 1);
					} else if (state.formData.Rate.value.indexOf(".") > value.indexOf(".")) {
						value = value.slice(0, value.lastIndexOf(".")) + value.slice(value.lastIndexOf(".") + 1);
					} else if (state.formData.Rate.value.indexOf(".") === value.indexOf(".")) {
						value = value.slice(0, value.indexOf(".")) + value.slice(value.indexOf(".") + 1);
					}
				}
				if (decimalCount > 2) {
					value = value.replace(/[.]/g, "");
					value = parseInt(value);
				}
			} else if (!state.formData.Rate) {
				value = value.replace(/[.]/g, "");
				value = parseInt(value);
			}
		}
		if (typeof value === "string") {
			if (value.indexOf(".") !== -1) {
				if (value.slice(value.indexOf(".") + 1).length > 5) {
					value = value.slice(0, value.indexOf(".") + 1) + value.slice(value.indexOf(".") + 1, value.indexOf(".") + 6);
				}
			}
		}
		update(dataConfig, name, value, id, "Currency");
	},

	/* Handle Currency Input State Change */
	handleCurrencyChange: (value, name, dataConfig, id, dataType, update) => {
		update(dataConfig, name, value, id, "Currency");
	},

	/* Handle React Select Wrapper State Change */
	handleSelectChange: (selectedOption, selectName, dataConfig, id, dataType, update) => {
		update(dataConfig, selectName, selectedOption, id, dataType);
	},

	handleDateChange: (name, date, dataConfig, id, dataType, update) => {
		update(dataConfig, name, date, id, dataType);
	},

	handleAdvertiserInputChange: (event, update, type, validation, advertiser, fieldValidationString) => {
		const dataConfig = event.target.dataset.config;
		let { value, name, id } = event.target;
		if (type === "text") {
			value = value.replace(/[^a-zA-Z0-9 \-]/g, "");
			if (value.length > 25) {
				value = value.substring(0, 25);
			}
			update(dataConfig, name, value, id, "String", advertiser);
		} else if (type === "number") {
			value = value.replace(/[^0-9]/g, "");
			if (value.length > 25) {
				value = value.substring(0, 25);
			}
			if (!isNaN(value)) {
				update(dataConfig, name, value, id, "String", advertiser);
			}
		} else if (type === "TaxOrMeta") {
			if (!fieldValidationString) {
				if (validation !== null && validation.length !== 0) {
					let formattedValidation = validation[0].substring(validation[0].indexOf("["), validation[0].lastIndexOf("]") + 1);
					formattedValidation = formattedValidation.substring(0, 1) + "^" + formattedValidation.substring(1, formattedValidation.length);
					if (formattedValidation.indexOf("\\\\\\") !== -1) {
						formattedValidation =
							formattedValidation.substring(0, formattedValidation.indexOf("\\\\\\")) +
							"\\\\\\" +
							formattedValidation.substring(formattedValidation.indexOf("\\\\\\") + 1, formattedValidation.length);
					}
					value = value.replace(new RegExp(formattedValidation, "g"), "");
				} else if (validation === null || validation.length === 0) {
					value = value.replace(/[^a-zA-Z0-9-\\/| +]/g, "");
				}
			}
			if (validation !== null && validation.length !== 0 && validation[1] !== undefined) {
				if (value.length > parseInt(validation[1])) {
					value = value.substring(0, parseInt(validation[1]));
				}
			} else if (validation === null || validation.length === 0 || validation[1] === undefined) {
				if (value.length > 30) {
					value = value.substring(0, 30);
				}
			}
			update(dataConfig, name, value, id, "String", advertiser);
		} else {
			update(dataConfig, name, value, id, "String", advertiser);
		}
	},

	/* Handle Currency Input State Change */
	handleAdvertiserCurrencyChange: (value, name, dataConfig, id, dataType, update, advertiser) => {
		update(dataConfig, name, value, id, "Currency", advertiser);
	},

	/* Handle React Select Wrapper State Change */
	handleAdvertiserSelectChange: (selectedOption, selectName, dataConfig, id, dataType, update, advertiser) => {
		update(dataConfig, selectName, selectedOption, id, dataType, advertiser);
	},

	handleAdvertiserDateChange: (name, date, dataConfig, id, dataType, update, advertiser) => {
		update(dataConfig, name, date, id, dataType, advertiser);
	}
};

export const VALIDATION_ERROR_MESSAGE = "This freeform field's value must be a decimal or whole number.";

export default ChangeEvents;
